var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Typography } from '../../../foundations/typography';
import styles from './TableCell.module.scss';
/**
 * @tdr
 * @tdr-deprecated-props: testId
 * @tdr-deprecated-date: 2022-07-07
 */
export var TableCell = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.alignment, alignment = _c === void 0 ? 'left' : _c, _d = _a.verticalAlign, verticalAlign = _d === void 0 ? 'baseline' : _d, className = _a.className, testId = _a.testId, props = __rest(_a, ["alignment", "verticalAlign", "className", "testId"]);
    var classNames = cx(styles.tableCell, (_b = {},
        _b[styles.center] = alignment === 'center',
        _b[styles.right] = alignment === 'right',
        _b[styles.top] = verticalAlign === 'top',
        _b[styles.bottom] = verticalAlign === 'bottom',
        _b), className);
    return (React.createElement(Typography, __assign({ ref: ref, element: "td", className: classNames, "data-test": testId, styleAs: "paragraph", noMargins: true }, props)));
});
//# sourceMappingURL=TableCell.js.map